export enum GeneratorProductStatus {
  NotSaved = 'NotSaved',
  NeedForUpdate = 'NeedForUpdate',
  Updated = 'Updated',
}
